setTimeout(()=> import('fixtures/commands/crossfilter/counts'), 2000); //trigger population creation always, for now
/*
All fixture functions are executed with `this` bound to `storage` context.
Data they save on `this` will be available for the duration of the page session.

Functions they should all have access to should be added to this object
 */

const storage = {};
window.fixture_storage = storage;

/* sortAndFilter(data, {filters, sort_by, sort_dir})
 * provides simple, but passable implementation of DataTable sorting and filtering for fixture data
 **/
storage.sortAndFilter = function(rows, params){
  const filters = params.filter || {};
  if(filters) rows = rows.filter((row)=> Object.entries(filters).every(([key, val])=> row[key].toLowerCase().indexOf(val.toLowerCase()) > -1));
  if(params.sort_by){
    const dir = params.sort_dir === 'asc' ? 1 : -1;
    rows = rows.sort((a,b)=> dir * (a[params.sort_by] > b[params.sort_by] ? 1 : -1));
  }
  return rows;
};

window.useFixtures = function(toggle = true){
  if (toggle) {
    return localStorage.setItem('useFixtures', toggle);
  } else {
    return localStorage.setItem('useFixtures', false);
    // return localStorage.removeItem('useFixtures');
  }
};

export function shouldUseFixtureFor(path){
  const useFixturesValue = localStorage.getItem('useFixtures');
  return useFixturesValue === 'true' || path.match(RegExp(useFixturesValue));
}

export default function fixture_request(type, name, params){
  return new Promise( (resolve, reject)=> {
    setTimeout(function(){
      const norm_name = name.replace(/[^\w/-]/g,'').toLowerCase();
      const endpoint = type === 'command' ? 'commands' : 'queries';
      try{
        import(`./${endpoint}/${norm_name}`).then((module)=> {
          const handler = module['default'];
          let response;
          if (typeof(handler) === 'function') {
            response = handler.call(storage, params);
          } else {
            response = handler;
          }
          console.log(`FIXTURE ${type.toUpperCase()}`, name, params, response);
          resolve(response);
        }, (err)=> console.error(`Failed fixture ${type}: `, name, params, err));
      } catch(ex){
        console.error(`Failed fixture ${type}: `, name, params, ex)
      }
    }, 10);
  });
}
fixture_request.command = fixture_request.bind(null, 'command');
fixture_request.query = fixture_request.bind(null, 'query');
